import React from 'react';
import DesktopNavigation from './desktop/DesktopNavigation';
import MobileNavigation from './mobile/MobileNavigation';
import { Responsive } from '../../../ui';

interface IProps {
	isSticky: boolean;
	className?: string;
}

export default function Navigation({ isSticky, className }: IProps) {
	const isSmallDesktop = !!Responsive.useMatchesBreakpoint('desktop');

	if (isSmallDesktop) {
		return <MobileNavigation className={className} isSticky={isSticky} />;
	}

	return <DesktopNavigation className={className} isSticky={isSticky} />;
}
